import { render, staticRenderFns } from "./ViewChangeRequestInsurerDetailsLegacy.vue?vue&type=template&id=49155b40"
import script from "./ViewChangeRequestInsurerDetailsLegacy.vue?vue&type=script&lang=ts"
export * from "./ViewChangeRequestInsurerDetailsLegacy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports